/**
 * HR Offer stage UI:
 *   — HR Teams call scheduling (recording + transcript)
 *   — HR Final call (enabled after interview + feedback completion)
 *
 * Negotiation capture + Offer AI evaluation were removed from the product
 * surface. Backend offer response APIs remain dormant.
 */
import React from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { HrFinalCallCard } from '@/components/HumanRatingsForms';
import { PanelInterviewsTab } from '@/components/PanelInterviewsTab';

export function OfferTab({
  candidateId,
  candidateEmail,
  disabled = false,
  evaluationId = null,
}) {
  return (
    <div className="space-y-4" data-testid="offer-tab-root">
      {!evaluationId && (
        <Card className="card-elevated">
          <CardContent className="p-4 text-sm text-muted-foreground">
            Select an evaluation to manage the Offer / HR round.
          </CardContent>
        </Card>
      )}
      <PanelInterviewsTab
        candidateId={candidateId}
        candidateEmail={candidateEmail}
        disabled={disabled || !evaluationId}
        panelKind="hr"
        evaluationId={evaluationId}
      />
      <HrFinalCallCard candidateId={candidateId} evaluationId={evaluationId} />
    </div>
  );
}

export default OfferTab;
